import { inject, Injectable, signal } from '@angular/core';
import { ShellDataService} from '../state/shell-data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthSessionPromotersUtil {

    shellDataService = inject(ShellDataService);

    private _isLoggedIn = signal<boolean>(!!localStorage.getItem('accessToken'));

    isLoggedIn = this._isLoggedIn.asReadonly();

    login() {
        this._isLoggedIn.set(true);
        this.shellDataService.redirectPerfilStorage();
    }

    logout() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('pathState');
        this._isLoggedIn.set(false);
    }

}
